/** True when the API rejected a mutation because the donation is already paid. */
export function isDonationAlreadyPaidError(error) {
  if (error == null) {
    return false;
  }

  // goRequest / goRequestWithRecaptcha reject with error.response.data (see httpClient.js).
  if (typeof error === 'string') {
    return error.toLowerCase().includes('donation already paid');
  }

  if (typeof error !== 'object') {
    return false;
  }

  const status = error.status ?? error.statusCode ?? error.response?.status;
  if (status === 409) {
    return true;
  }

  const messages = [
    error.error,
    error.message,
    error.response?.data?.error,
    typeof error.response?.data === 'string' ? error.response.data : null,
  ].filter((value) => value != null && value !== '');

  return messages.some((msg) =>
    String(msg).toLowerCase().includes('donation already paid')
  );
}
